export class FeeTypeMismoApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getList() {
    return this.#http.get('/api/fee-types/mismo-fee-types');
  }
}
